import * as React from "react";

interface Props {
    layer: number;
    type: "group" | "item" | "total";
}

export default class ReportTableGroupIndicator extends React.Component<Props> {
    public render(): React.ReactNode {
        const indicators = [];

        for(let i = 0; i < this.props.layer; i++) {
            const classes = [ "report-table-group-indicator" ];

            if(i === this.props.layer - 1) {
                classes.push(this.props.type);
            } else {
                classes.push("group");
            }

            indicators.push(
                <span
                    key={i}
                    className={classes.join(" ")}
                    style={{
                        marginLeft: i * 32 + "px",
                    }}
                />
            );
        }

        return indicators;
    }
}
